import { createApp } from 'vue'
import axios from 'axios'
import Locations from './locations.vue'
import VueGoogleMaps from 'vue-google-maps-community-fork'

import { Choices } from 'choices.js'

export const app = createApp({
	data() {
		return {
			locations: [],
			translations: [],
			locationCategories: [],
			locationServices: [],
			loading: true,
			options:
			{
				scrollwheel: false,
				disableDefaultUI: true,
				zoomControl: true,
				streetViewControl: false,
				mapTypeControl: false,
				styles:
				[
					{"featureType":"administrative","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"simplified"},{"lightness":"14"}]},{"featureType":"landscape.man_made","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"simplified"},{"saturation":"-46"},{"lightness":"32"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"simplified"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"hue":"#00b4ff"},{"lightness":"3"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"saturation":-61.8},{"lightness":45.599999999999994},{"gamma":1},{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"visibility":"on"},{"saturation":"-98"},{"hue":"#ff00a6"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels.icon","stylers":[{"hue":"#00b4ff"}]},{"featureType":"transit.line","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.airport","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.rail","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.rail","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"hue":"#0078FF"},{"saturation":-13.200000000000003},{"lightness":2.4000000000000057},{"gamma":1}]},{"featureType":"water","elementType":"geometry","stylers":[{"visibility":"simplified"},{"color":"#d8edf5"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#bad4f2"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]}
				]
			}
		};
	},
	mounted() {
		const url = document.body.getAttribute('data-base-url');

		axios.get(url + 'locations/locations-categories.json')
		.then(response => {
			this.locationCategories = response.data.categories;
			this.locationServices = response.data.services;
		});

		axios.get(url + 'locations/locations.json')
		.then(response => {
			this.locations = response.data.categories;
			this.translations = response.data.translations;
			this.loading = false;
		});
	}
});

app.use(VueGoogleMaps, {
	load: {
	  key: 'AIzaSyDuBvA5DOpTJBBFg8-e3Pkyxq_cPpjA58M'
	}
});

app.component('locations', Locations);
app.mount('#locations-app');
